import React from "react";
import { Alert, Button, Typography } from "@mui/material";
import { DtDialog } from "../../ui/dialog";
import DtAlert from "../../ui/alert/DtAlert";

interface UnsavedChangesDialogProps {
    open: boolean;
    onSaveAndContinue: () => void | Promise<void>;
    onDiscard: () => void | Promise<void>;
    onCancel: () => void | Promise<void>;
    loading?: boolean;
    errorMessage?: string;
    title?: string;
    message?: string;
    saveLabel?: string;
    showDiscard?: boolean;
    infoMessage?: string;
}

const UnsavedChangesDialog: React.FC<UnsavedChangesDialogProps> = ({
    open,
    onSaveAndContinue,
    onDiscard,
    onCancel,
    loading = false,
    errorMessage,
    title = "Unsaved Changes",
    message = "You have made changes to the configuration. Save them before returning to Home.",
    saveLabel = "Save and Continue",
    showDiscard = true,
    infoMessage,
}) => (
    <DtDialog
        open={open}
        onClose={onCancel}
        title={title}
        maxWidth="xs"
        actions={
            <>
                <Button variant="outlined" size="small" onClick={onCancel} disabled={loading}>
                    Cancel
                </Button>
                {showDiscard && (
                    <Button variant="outlined" size="small" onClick={onDiscard} disabled={loading}>
                        Discard
                    </Button>
                )}
                <Button variant="contained" size="small" onClick={onSaveAndContinue} disabled={loading}>
                    {saveLabel}
                </Button>
            </>
        }
    >
        <Typography>{message}</Typography>
        {infoMessage && (
            <DtAlert severity="info" sx={{ mt: 2 }}>
                {infoMessage}
            </DtAlert>
        )}
        {errorMessage && (
            <Alert severity="error" sx={{ mt: 2 }}>
                {errorMessage}
            </Alert>
        )}
    </DtDialog>
);

export default UnsavedChangesDialog;
